import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orangehrm-background-container" }
const _hoisted_2 = { class: "orangehrm-paper-container" }
const _hoisted_3 = { class: "orangehrm-header-container" }
const _hoisted_4 = { class: "orangehrm-container" }
const _hoisted_5 = { class: "orangehrm-bottom-container" }

import {APIService} from '@/core/util/services/api.service';
import {ref, computed} from 'vue';
import usePaginate from '@/core/util/composable/usePaginate';
import useSort from '@ohrm/core/util/composable/useSort';
import Tooltip from '@/core/components/inputs/IconButton';
import useToast from '@/core/util/composable/useToast';


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationResultsTable',
  props: {
  informationId: {type: Number},
},
  setup(__props) {

const {success} = useToast();

const props = __props;

const http = new APIService(
  window.appGlobal.baseUrl,
  `api/training/answers/list?informationId=${props.informationId}`,
);

const defaultSortOrder = {
  response: 'DESC',
};

const {sortDefinition, sortField, sortOrder, onSort} = useSort({
  sortDefinition: defaultSortOrder,
});

const serializedFilters = computed(() => {
  return {
    sortOrder: sortOrder.value,
    sortField: sortField.value,
  };
});

const {
  showPaginator,
  currentPage,
  total,
  pages,
  pageSize,
  response,
  isLoading,
  execQuery,
} = usePaginate(http, {
  query: serializedFilters,
  pageSize: 5,
  toastNoRecords: false,
});

onSort(execQuery);

const notifyEmployeeForInfo = async (row: any) => {
  isLoading.value = true;
  await http
    .request({
      method: 'POST',
      url: `api/training/answers/notify/${props.informationId}`,
      data: {
        employeeId: row.id,
      },
    })
    .then(() => {
      success({title: 'Success', message: 'Notification send to user'});
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const generateActions = (...args: any[]) => {
  const [index, , , row] = args;

  if (row && row.response == 'Yes') return {props: {header: {cellConfig: {}}}};
  return {
    props: {
      header: {
        cellConfig: {
          notify: {
            onClick: notifyEmployeeForInfo,
            component: Tooltip,
            props: {
              name: 'envelope-fill',
              title: 'Notify for info',
            },
          },
        },
      },
    },
  };
};

const headers = ref([
  {name: 'name', title: 'Assigned to', style: {flex: '22.5%'}},
  {
    name: 'response',
    title: 'Response',
    style: {flex: '22.5%'},
    sortField: 'response',
  },
  {name: 'time', title: 'Time to complete', style: {flex: '22.5%'}},
  {name: 'created_at', title: 'Response at', style: {flex: '22.5%'}},
  {
    name: 'actions',
    title: 'Actions',
    style: {flex: '10%'},
    cellType: 'oxd-table-cell-actions',
    cellRenderer: generateActions,
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _component_oxd_card_table = _resolveComponent("oxd-card-table")!
  const _component_oxd_pagination = _resolveComponent("oxd-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_oxd_text, { tag: "span" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.n_records_found', {count: _unref(total)})), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_oxd_card_table, {
          order: _unref(sortDefinition),
          "onUpdate:order": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sortDefinition) ? (sortDefinition).value = $event : null)),
          headers: headers.value,
          items: _unref(response)?.data,
          selectable: false,
          clickable: false,
          loading: _unref(isLoading),
          "row-decorator": "oxd-table-decorator-card"
        }, null, 8, ["order", "headers", "items", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(showPaginator))
          ? (_openBlock(), _createBlock(_component_oxd_pagination, {
              key: 0,
              current: _unref(currentPage),
              "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
              length: _unref(pages)
            }, null, 8, ["current", "length"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})